import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { match } from 'fuzzy';
import { UtilityHelper } from '../helpers';

@Pipe({
  name: 'onyxHighlight',
})
export class OnyxHighlightPipe implements PipeTransform {
  public transform(value: string, query: string): string {
    if (!query) return value;

    query = UtilityHelper.toCompareString(query);

    return (
      match(query, value, {
        pre: '<span class="f-highlight">',
        post: '</span>',
      })?.rendered || value
    );
  }
}
